import {
  Modal,
  View,
  Image,
  StyleSheet,
  Platform,
  Dimensions,
  PixelRatio,
} from "react-native";
import { useMemo } from "react";
import LoadingSpinner from "../LoadingSpinner";
import variables from "../../styles/variables";

const { width: screenWidth, height: screenHeight } = Dimensions.get("window");

const logo = require("../../assets/logo-long.png"); // Default logo, can be overridden by props

/**
 * FakeSplashScreen component overtakes the native splash screen
 * on mobile platforms to provide a custom loading experience.
 * @returns {JSX.Element|null} The rendered component or null if on web platform.
 */
const FakeSplashScreen = (): JSX.Element | null => {
  if (Platform.OS === "web") return;

  // Memoize the image component so it doesn't re-render unnecessarily
  const memoizedImage = useMemo(() => {
    if (!logo) return null;
    const asset = Image.resolveAssetSource(logo);

    if (asset?.width && asset?.height) {
      const pixelRatio = PixelRatio.get();
      const assetWidth = asset.width / pixelRatio;
      const assetHeight = asset.height / pixelRatio;
      const scaleFactor = Math.min(
        screenWidth / assetWidth,
        screenHeight / assetHeight
      );
      const imageSize = {
        width: assetWidth * scaleFactor,
        height: assetHeight * scaleFactor,
      };

      if (imageSize.width > 0) {
        return (
          <Image
            source={logo}
            style={{
              resizeMode: "contain",
              width: imageSize.width,
              height: imageSize.height,
            }}
            fadeDuration={0}
          />
        );
      }
    }
  }, []);

  return (
    <Modal animationType="fade" visible>
      <View style={styles.fakeSplashScreenContainer}>{memoizedImage}</View>
      <View style={styles.loadingContainer}>
        <LoadingSpinner color="white" />
      </View>
    </Modal>
  );
};

export default FakeSplashScreen;

const styles = StyleSheet.create({
  fakeSplashScreenContainer: {
    flex: 1,
    width: "100%",
    backgroundColor: variables.colors.palette.rtv.primary,
    // backgroundColor: "orange", // test fake splash
    justifyContent: "center",
    alignItems: "center",
  },
  loadingContainer: {
    position: "absolute",
    bottom: "25%",
    justifyContent: "center",
    width: "100%",
  },
});
